import _ from "lodash";
import {MessageActionEvaluator} from "./MessageActionEvaluator";
import menuOptions from "./MessageActionMenuOptions";

/**
 * @param message {Object}
 * @returns {Object[]}
 */
export function getSupportedActions(message) {
    const evaluator = new MessageActionEvaluator(message);
    return evaluateFeatures(menuOptions, evaluator);
}

/**
 * @param actions {Object[]}
 * @param evaluator {MessageActionEvaluator}
 * @returns {Object[]}
 */
function evaluateFeatures(actions, evaluator) {
    return _.filter(actions, (action) => evaluator.evaluate(action));
}